<template>
	<!-- 升学途径 -->
    <div class="wayToStudy">
		<router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "wayToStudy"
    }
</script>

<style scoped>
	.wayToStudy {
		padding-left: 20px;
	}
</style>
